module.exports = __webpack_public_path__ + "static/tinker-tailor-soldier-spy-dced7ce912a3572edb1ffd4e206fc7d1.jpg";